import { getImgUrl } from '@utils/functions/getImgUrl';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { HiArrowTrendingUp } from 'react-icons/hi2';

const CardSuccessStories = ({ item, queryString }) => {
  const {
    studentName,
    studentDesignation,
    videoLink,
    title,
    tagline,
    cardImage,
    slug,
    linkedinUrl,
    avatar,
    companyLogo,
    placedAt,
    domain,
    workExperience,
    background,
    hike,
  } = item?.attributes;

  const USER_KEY = {
    background,
    workExperience,
    domain,
  };

  const KEY_MAP = {
    background: {
      bgColor: '#B9E6FE',
      textColor: '#026AA2',
    },

    workExperience: {
      bgColor: '#FCCEEE',
      textColor: '#C11574',
    },

    domain: {
      bgColor: '#ABEFC6',
      textColor: '#137a4e',
    },
  };

  const VALUE_MAP = {
    dataScience: 'Data Science',
    web3: 'Web Development',
    tech: 'Tech Background',
    nonTech: 'Non-Tech Background',
    fresher: 'Fresher',
    zeroToTwo: 'Working Professional',
    twoToFive: 'Working Professional',
    fivePlus: 'Working Professional',
  };

  return (
    <Link
      href={queryString ? `/success-stories/${slug}?${queryString}` : `/success-stories/${slug}`}
      as={queryString ? `/success-stories/${slug}?${queryString}` : `/success-stories/${slug}`}
      passHref
    >
      <a
        className={`grid  h-full cursor-pointer grid-rows-2 overflow-hidden rounded-xl bg-white shadow-md hover:shadow-lg`}
      >
        <div className="relative grid h-full w-full cursor-pointer bg-red">
          {hike && (
            <span className="absolute left-3 top-3 flex items-center gap-x-1 rounded-full bg-white px-3 text-[14px]">
              <HiArrowTrendingUp size={16} />
              {hike}% Hike
            </span>
          )}
          <Image
            src={getImgUrl(avatar)}
            alt={studentName}
            loading="lazy"
            width={200}
            height={256}
            objectFit="contain"
          />
          <div className="absolute bottom-0 z-10 flex h-16 w-full flex-row items-center justify-between bg-gray-300 bg-opacity-20 px-5 py-4 text-white backdrop-blur-md">
            <div className="flex flex-col items-start">
              <p className="font-satoshi-medium text-sm font-semibold"> {studentName}</p>
              <p className="text-sm font-thin"> {studentDesignation}</p>
            </div>
            <div className="flex flex-col items-end gap-y-1 text-end">
              <p className="font-satoshi-medium text-sm font-semibold"> Placed At</p>
              {companyLogo?.data !== null ? (
                <img
                  src={getImgUrl(companyLogo)}
                  alt={studentName}
                  loading="lazy"
                  className="h-6 rounded-md bg-white object-contain px-2 py-0.5"
                />
              ) : (
                <p className="text-sm font-thin !leading-5">{placedAt}</p>
              )}
            </div>
          </div>
        </div>

        <div className="flex h-full flex-col gap-y-[16px] px-[16px] py-[24px] text-left">
          <div className="flex flex-wrap gap-[8px]">
            {Object.entries(USER_KEY).map(([key, value], index) => {
              if (!value) {
                return;
              }

              return (
                <div
                  key={index + 1}
                  className="h-fit rounded px-[8px] py-[4px]"
                  style={{ backgroundColor: KEY_MAP[key]?.bgColor }}
                >
                  <p
                    className="font-satoshi-medium text-[14px] leading-4"
                    style={{ color: KEY_MAP[key]?.textColor }}
                  >
                    {VALUE_MAP[value]}
                  </p>
                </div>
              );
            })}
          </div>

          <p className="font-satoshi-bold text-[18px] leading-6 line-clamp-4 md:text-[20px] md:leading-7">
            {title}
          </p>

          {/* <div className="px-4 text-xs font-normal">
            {tagline.slice(0, 100)}
            {tagline.length > 80 && '...'}
          </div> */}
          <p className="mt-auto self-end font-satoshi-medium text-base text-[#0A66C2] hover:underline">
            Read More
          </p>
        </div>
      </a>
    </Link>
  );
};

export default CardSuccessStories;
